export const TRACK_ACTION_CART_ADD = {
  actionGA: 'addToCart',
};
export const TRACK_ACTION_CART_REMOVE = {
  actionGA: 'removeFromCart',
};
// ADD/REMOVE
export const TRACK_CLICK_EVENT_CART_ADD_RENTAL = { ...TRACK_ACTION_CART_ADD, labelGA: 'ski' };
export const TRACK_CLICK_EVENT_CART_REMOVE_RENTAL = { ...TRACK_ACTION_CART_REMOVE, labelGA: 'ski' };
